import React from "react";
import { useLanguage } from '../../context/LanguageContext';
import './FormList.css';

const FormList = ({ forms }) => {
    const { t, lang } = useLanguage();

    return (
        <section className="wpo-shop-section">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="shop-grids clearfix">
                            {forms.length > 0 &&
                                forms.map((form, pitem) => {
                                    // EN versiyonu varsa kullan, yoksa TR'ye fallback
                                    const enLink = form.link.replace('/assets/forms/', '/assets/forms/en/');
                                    const pdfLink = (lang === 'en' && form.linkEn) ? form.linkEn : form.link;

                                    return (
                                        <div className="grid" key={pitem}>
                                            <div className="img-holder">
                                                <img
                                                    src={form.proImg}
                                                    alt={form.title}
                                                    style={{ height: '200px', objectFit: 'contain', padding: '20px' }}
                                                />
                                            </div>
                                            <div className="details">
                                                <h3>
                                                    <a href={pdfLink} target="_blank" rel="noopener noreferrer">
                                                        {lang === 'en' && form.titleEn ? form.titleEn : form.title}
                                                    </a>
                                                </h3>
                                                <a
                                                    href={pdfLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="theme-btn-s2"
                                                >
                                                    {t('forms.viewPdf')}
                                                </a>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FormList;
